<Slide :i :slide>

    <div class="i-waves {{ c('play-waves', play_waves) }}">

    {{#each slide.text_list as text_item, n}}
    <div class="slide__text slide__text--{{ n + 1 }} slide__text--interactive step">
        {{#if show_visuals}}

            {{#if text_item.type == 'Text'}}
                <p class="slide__text-inner" transition:fade>{{ text_item.text }}</p>
            {{elseif text_item.type == 'Video' }}
                <Modal slideIndex={{i}} modalIndex={{n}} modal={{text_item}} />
            {{elseif text_item.type == 'Aside' }}
                <Modal slideIndex={{i}} modalIndex={{n}} modal={{$science_asides[text_item.slug]}} />
            {{else}}
                <p class="slide__text-inner" transition:fade>{{ text_item }}</p> 
            {{/if}}

        {{/if}}
    </div>

    {{/each}}

        <div class="media-outer interactive">

            <video muted playsinline class="show" ref:video on:ended="introEnd(event)">
                <source src="{{ video('slr_waves_1_intro.webm') }}" type="video/webm">
                <source src="{{ video('slr_waves_1_intro.mp4') }}" type="video/mp4">
            </video>

            <div ref:loops class="loops">
                <video muted loop class="media-video">
                    <source src="{{ video('slr_waves_2_calm.webm') }}" type="video/webm">
                    <source src="{{ video('slr_waves_2_calm.mp4') }}" type="video/mp4">
                </video>
                
                <video muted loop playsinline class="media-video">
                    <source src="{{ video('slr_waves_3_flood.webm') }}" type="video/webm">
                    <source src="{{ video('slr_waves_3_flood.mp4') }}" type="video/mp4">
                </video>
                
                <video muted loop playsinline class="media-video">
                    <source src="{{ video('slr_waves_4_damage.webm') }}" type="video/webm">
                    <source src="{{ video('slr_waves_4_damage.mp4') }}" type="video/mp4">
                </video>
            </div>

            <audio ref:audio>
                <source src="{{ media('audio/vo/Iz_Audio_IceMelts.mp3') }}" type="audio/mp3">
                <track ref:track src="subtitles/vtt/sea_level.vtt" 
                    label="English captions" kind="metadata" srclang="en" default>
            </audio>

            <div class="interactive__layer">

                <div class="i-waves__wave-outer">
                    <div class="i-waves__wave i-waves__wave--intro {{ c('show-wave', waves.has('intro')) }}"></div>
                    <div class="i-waves__wave i-waves__wave--flat {{ c('show-wave', waves.has('flat')) }}" style="bottom: {{ bottom }}%;"></div>
                    <div class="i-waves__wave i-waves__wave--1 {{ c('show-wave', waves.has('first')) }}" style="bottom: {{ bottom }}%;"></div>
                    <div class="i-waves__wave i-waves__wave--2 {{ c('show-wave', waves.has('second')) }}" style="bottom: {{ bottom }}%;"></div>
                    <div class="i-waves__wave i-waves__wave--3 {{ c('show-wave', waves.has('third')) }}" style="bottom: {{ bottom }}%;"></div>
                    <div class="i-waves__wave i-waves__wave--repeat {{ c('show-wave', waves.has('repeat')) }}" style="bottom: {{ bottom }}%;"></div>
                </div>
            </div>

        </div>
        <Captions ref:display :cues />

    </div>

</Slide>

<script>
import Slide from '../Slide.html'
import Captions from '../video/Captions.html'
import Modal from '../Modal.html'
import { classed, isReverse, media, video, noop, syncCues } from '../helpers'
import { waves } from '../sfx'

import { fade } from 'svelte-transitions'
import { timeout } from 'd3-timer'


export default {

    components: {
        Slide,
        Captions,
        Modal
    },

    transitions: {
        fade
    },

    data() {

        return {
            cues: [],
            slide: {
                text_list: []
            },

            play_waves: false,
            show_visuals: false,
        }
    },

    computed: {
        waves: ($bullet, i) => {

            const [slide, bullet] = $bullet || [];

            if (slide < i) {
                return new Set(['flat', 'repeat']);
            }

            if (slide > i) {
                return new Set(['third', 'repeat']);
            }

            // slide === i
            switch (bullet) {

                case 0: return new Set(['first', 'repeat']);
                case 1: return new Set(['second', 'repeat']);
                case 2: return new Set(['third', 'repeat']);

                default: return new Set(['third', 'repeat']);
            }
        },

        // calculate bottom percent for waves based on step
        bottom: ($bullet, i) => {

            const [slide, bullet] = $bullet || [];
            const levels = [20, 22.4691358024691, 28.3950617283951];

            if (slide < i) {
                return levels[0];
            }

            if (slide > i) {
                return levels[levels.length - 1];
            }

            return levels[bullet];

        }
    },

    oncreate() {
        window.waves = this;
        this.observers = [];

        this.observers.push(this.store.observe('muted', muted => {
            this.refs.audio.muted = muted;
        }));

        this.observers.push(this.store.observe('bullet', (current, prev) => {
            const [slide, bullet] = current || [];
            const reverse = isReverse(current, prev);
            const i = this.get('i');

            if (slide === i + 1) {
                this.pause();
                return this.setLoop(2);
            }

            if (slide === i - 1) {
                this.refs.video.classList.add('show');
                this.setLoop(-1);
                return this.set({ show_visuals: false });
            }

            if (slide !== i) return;

            // slide === i
            switch (bullet) {

                case 0:
                    if (this.get('show_visuals')) {
                        return this.setLoop(0);
                    } else {
                        return this.play();
                    }

                    break;

                case 1:
                    waves[1].play();
                    return this.setLoop(1);

                case 2:
                    waves[2].play();
                    return this.setLoop(2);

            }

        }));

        syncCues(this.refs.track, this.refs.display);
    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel();
        }
    },

    methods: {
        play(restart) {
            const { video, audio } = this.refs;
            this.set({ show_visuals: false, play_waves: false });
            
            if (video) {
                //video.currentTime = 0;
                video.play()
                    .catch(noop)
                    .then(() => {
                        this.setLoop(-1);
                        this.playWaves(10250 - video.currentTime);

                        this.store.deck.freeze()
                    });
            }

            audio && audio.play().catch(noop);

        },

        pause() {
            const { video, audio } = this.refs;

            video && video.pause();
            audio && audio.pause();
        },

        playWaves(delay) {
            // time the waves
            timeout(() => {
                this.set({ play_waves: true })
                waves[0].play();
            }, delay);
        },

        introEnd(e) {
            this.store.deck.unfreeze();
            this.set({ show_visuals: true });
            this.setLoop(0, e);
        },

        setLoop(n, e) {

            // play and show the loop
            for (let i = this.refs.loops.children.length - 1; i >= 0; i--) {
                const video = this.refs.loops.children[i];

                if (n === i) {
                    video.play().catch(noop);
                    video.classList.add('show');
                } else {
                    timeout(() => {
                        video.classList.remove('show');
                        video.pause();
                    }, 100);
                }
            }

            if (e) {
                // when intro video ends
                e.target.classList.remove('show');
            }
        }
    },

    helpers: {
        media,
        video,
        c: classed,
    }
}
</script>